import { DocFlowTableName } from './docFlow'

export const BUILDING_ENTITY = { plural: 'buildings', single: 'building' }

export const USER_STAFF_MEMBER_BUILDINGS_ENTITY = {
  plural: 'staff-member-buildings',
  single: 'building',
}

export const CONTRACTOR_BUILDINGS_ENTITY = {
  plural: 'contractor-buildings',
  single: 'building',
}

export const CONTRACTOR_REQUESTS_ENTITY = {
  plural: 'contractor-requests',
  single: 'request',
}

export const SEARCH_RESULTS_BUILDINGS_ENTITY = {
  plural: 'buildings-search',
  single: 'building',
}

export const BUILDING_GROUP_ENTITY = {
  plural: 'building-groups',
  single: 'building-group',
}

export const BUILDING_BUILDING_GROUPS_ENTITY = {
  plural: 'building-building-groups',
  single: 'building-group',
}

export const BUILDING_GROUP_BUILDINGS_ENTITY = {
  plural: 'building-group-buildings',
  single: 'building',
}

export const LABEL_ENTITY = {
  plural: 'labels',
  single: 'label',
}

export const REQUEST_DOCUMENTS_ENTITY = {
  plural: 'request-documents',
  single: 'document',
}

export const EMAIL_ENTITY = { plural: 'email-threads', single: 'email' }

export const DOCUMENTS_ENTITY = { plural: 'documents', single: 'document' }

export const USER_DOCUMENTS_ENTITY = {
  plural: 'user-profile-documents',
  single: 'document',
}

export const BUILDING_DOCUMENTS_ENTITY = {
  plural: 'building-documents',
  single: 'document',
}

export const BUILDING_GROUP_DOCUMENTS_ENTITY = {
  plural: 'building-group-documents',
  single: 'document',
}

export const SEARCH_RESULTS_EMAILS_ENTITY = {
  plural: 'email-messages-search',
  single: 'email',
}

export const SINGLE_EMAIL_ENTITY = {
  plural: 'email-messages',
  single: 'single-email',
}

export const USER_EMAILS_ENTITY = {
  plural: 'user-profile-email-messages',
  single: 'single-email',
}

export const FLAT_ENTITY = { plural: 'flats', single: 'flat' }

export const BUILDING_FLATS_ENTITY = {
  plural: 'building-flats',
  single: 'flat',
}

export const BUILDING_GROUP_FLATS_ENTITY = {
  plural: 'building-group-flats',
  single: 'flat',
}

export const SEARCH_RESULTS_FLATS_ENTITY = {
  plural: 'flats-search',
  single: 'flat',
}

export const INHABITANT_ENTITY = { plural: 'inhabitants', single: 'inhabitant' }

export const SEARCH_RESULTS_INHABITANTS_ENTITY = {
  plural: 'inhabitants-search',
  single: 'inhabitant',
}

export const REQUEST_ENTITY = { plural: 'requests', single: 'request' }

export const BUILDING_REQUESTS_ENTITY = {
  plural: 'building-requests',
  single: 'request',
}

export const BUILDING_GROUP_REQUESTS_ENTITY = {
  plural: 'building-group-requests',
  single: 'request',
}

export const SEARCH_RESULTS_REQUESTS_ENTITY = {
  plural: 'requests-search',
  single: 'request',
}

export const RELATED_REQUESTS_ENTITY = {
  plural: 'request-related-requests',
  single: 'request-related-request',
}

export const USER_REQUESTS_ENTITY = {
  plural: 'inhabitant-requests',
  single: 'request',
}

export const STAFF_MEMBER_REQUESTS_ENTITY = {
  plural: 'staff-member-requests',
  single: 'request',
}

export const STAFF_MEMBER_REQUEST_CATEGORIES_ENTITY = {
  plural: 'staff-member-request-categories',
  single: 'request-category',
}

export const CONTRACTOR_REQUEST_CATEGORIES_ENTITY = {
  plural: 'contractor-request-categories',
  single: 'request-category',
}

export const REQUEST_THREAD_ENTITY = {
  plural: 'request-threads',
  single: 'request-thread',
}

export const TASK_ENTITY = { plural: 'activities', single: 'activity' }

export const PROVIDER_ENTITY = { plural: 'contractors', single: 'contractor' }

export const RENTAL_APPLICANT_ENTITY = {
  plural: 'rental-portal-applicants',
  single: 'rental-portal-applicant',
}

export const RENTAL_LISTING_ENTITY = {
  plural: 'rental-portal-listings',
  single: 'rental-portal-listing',
}

export const RENTAL_LISTING_DOCUMENTS_ENTITY = {
  plural: 'rental-portal-listing-documents',
  single: 'document',
}

export const RENTAL_VIEWING_ENTITY = {
  plural: 'rental-portal-viewings',
  single: 'rental-portal-viewing',
}

export const BUILDING_PROVIDERS_ENTITY = {
  plural: 'building-contractors',
  single: 'contractor',
}

export const SEARCH_RESULTS_PROVIDERS_ENTITY = {
  plural: 'contractors-search',
  single: 'contractor',
}

export const NEWSBOARD_ENTITY = { plural: 'news', single: 'news' }

export const BUILDING_POSTS_ENTITY = {
  plural: 'building-posts',
  single: 'news',
}

export const BUILDING_GROUP_POSTS_ENTITY = {
  plural: 'building-group-posts',
  single: 'news',
}

export const USER_PROFILE_POSTS_ENTITY = {
  plural: 'user-profile-posts',
  single: 'news',
}

export const SEARCH_RESULTS_POSTS_ENTITY = {
  plural: 'news-search',
  single: 'news',
}

export const DOC_FLOW_ENTITY = {
  plural: DocFlowTableName.List,
  single: 'document-stapling',
}

export const REQUEST_DOC_FLOWS_ENTITY = {
  plural: DocFlowTableName.RequestConnected,
  single: DOC_FLOW_ENTITY.single,
}

export const DOC_FLOW_UPLOADING_ENTITY = {
  plural: DocFlowTableName.Uploading,
  single: 'document-stapling-uploading',
}

export const DOC_FLOW_COMBINING_ENTITY = {
  plural: DocFlowTableName.Combining,
  single: 'document-stapling-combining',
}

export const DOC_FLOW_SENDING_ENTITY = {
  plural: DocFlowTableName.Sending,
  single: 'document-stapling-sending',
}

export const DOC_FLOW_RESULT_ENTITY = {
  plural: DocFlowTableName.Result,
  single: 'document-stapling-result',
}

export const DOC_FLOW_MAPPING_RESULT_ENTITY = {
  plural: DocFlowTableName.MappingResult,
  single: DocFlowTableName.MappingResult,
}

export const CONTRACT_ENTITY = { plural: 'contracts', single: 'contract' }

export const BUILDING_INHABITANTS_ENTITY = {
  plural: 'building-inhabitants',
  single: 'inhabitant',
}

export const BUILDING_GROUP_INHABITANTS_ENTITY = {
  plural: 'building-group-inhabitants',
  single: 'inhabitant',
}

export const FLAT_CONTRACTS_ENTITY = {
  plural: 'flat-contracts',
  single: 'contract',
}

export const FLAT_DOCUMENTS_ENTITY = {
  plural: 'flat-documents',
  single: 'document',
}

export const FLAT_INHABITANTS_ENTITY = {
  plural: 'flat-inhabitants',
  single: 'inhabitant',
}

export const FLAT_REQUESTS_ENTITY = {
  plural: 'flat-requests',
  single: 'request',
}

export const USER_CONTRACTS_ENTITY = {
  plural: 'inhabitant-contracts',
  single: 'contract',
}

export const DWELLER_ENTITY = { plural: 'dwellers', single: 'dweller' }

export const LANDLORD_ENTITY = { plural: 'landlords', single: 'landlord' }

export const CHAT_ENTITY = { plural: 'chats', single: 'chat' }

export const FAQ_ENTITY = { plural: 'faqs', single: 'faq' }

export const EPOST_BILLING_TRANSACTIONS_ENTITY = {
  plural: 'epost-billing-transactions',
  single: 'epost-billing-transaction',
}

export const IDWELL_TO_IDWELL_ENTITY = {
  plural: 'idwell-to-idwell',
  single: 'idwell-to-idwell',
}

export const BUDGET_PLAN_DEFAULT_INVOICES_ENTITY = {
  plural: 'budget-plan-default-invoices',
  single: 'invoice',
}

export const BUDGET_PLAN_DOMUS_INVOICES_ENTITY = {
  plural: 'budget-plan-domus-invoices',
  single: 'invoice',
}
